module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-07-9b797a0c49364eadf83d871772e9b6b6.jpg";